import brandLogo from 'assets/logo-single.png'

const authBrandLogo = () => {
  return brandLogo
}

export default authBrandLogo
